<script setup lang='ts'>
const props = defineProps<{
	items: { emoji: string, label: string }[]
}>()

const firstRow = computed(() => props.items.slice(0, props.items.length / 2))
const secondRow = computed(() => props.items.slice(props.items.length / 2))
</script>

<template>
	<div
		class="relative max-h-1"
		data-aos="fade-up">
		<Marquee
			vertical
			pause-on-hover
			:repeat="2"
			class="[--duration:20s]">
			<MarqueePromptCard
				v-for="item in firstRow"
				:key="item.label"
				v-bind="item" />
		</Marquee>

		<Marquee
			pause-on-hover
			vertical
			reverse
			:repeat="2"
			class="[--duration:20s]">
			<MarqueePromptCard
				v-for="item in secondRow"
				:key="item.label"
				v-bind="item" />
		</Marquee>
	</div>
</template>
